import {
  FieldAccessRule,
  LoanAccessRule,
  PersonaAccessResponse,
} from '@frontend/epc';
export const SET_PERSONA_ACCESS_DATA = 'SET_PERSONA_ACCESS_DATA';
export const SET_FIELD_ACCESS_RULES = 'SET_FIELD_ACCESS_RULES';
export const SET_LOAN_ACCESS_RULES = 'SET_LOAN_ACCESS_RULES';

export const setPersonaAccessData = (payload: PersonaAccessResponse[]) => ({
  type: SET_PERSONA_ACCESS_DATA,
  payload,
});

export const setFieldAccessRules = (payload: FieldAccessRule[]) => ({
  type: SET_FIELD_ACCESS_RULES,
  payload,
});

export const setLoanAccessRules = (payload: LoanAccessRule[]) => ({
  type: SET_LOAN_ACCESS_RULES,
  payload,
});
